import { global } from 'data';
import { styled } from 'mymoria-ui';
import { Col, Markdown, Row } from 'mymoria-ui/components';
import React from 'react';

const TitleContainer = styled.div`
  padding: 1rem;
  margin: 1rem auto 2rem;
  width: fit-content;
  border-bottom: 2px solid #c9c9c9;
`;

const Title = styled.h1`
  margin: 0;
`;

// todo: should be adjusted to the new design
const NotFoundPage = () => (
  <Row justifyContent="center" style={{ padding: '4rem 2rem' }}>
    <Col width={1}>
      <TitleContainer>
        <Title>{global.notFound}</Title>
      </TitleContainer>
    </Col>
    <Col width={[1, 2 / 3, 1 / 3]}>
      <Markdown source={global.notFoundMessage} />
    </Col>
  </Row>
);

export default NotFoundPage;
